import React, { useContext } from "react";
import AbstractBenefitsDropdown from "./AbstractBenefitsDropdown";
import AbstractBenefitsTableList from "./AbstractBenefitsTableList";
import { Plan } from "../../../@types";
import { PreviewContext } from "../../../helpers";

const AbstractBenefitsContainer: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan: { abstract_benefits: abstractBenefits } }) => {
  const previewMode = useContext(PreviewContext);

  if (!abstractBenefits) {
    return null;
  }

  return previewMode ? (
    <AbstractBenefitsTableList abstractBenefits={abstractBenefits} />
  ) : (
    <AbstractBenefitsDropdown abstractBenefits={abstractBenefits} />
  );
};

export default AbstractBenefitsContainer;
